/** IMask pattern for ÅÅÅÅMMDDKKKK (12 digits, no separator). */
export const SSN_MASK = '000000000000'

/** Alphanumeric mask when interim numbers (letters in num part) are allowed. */
export const SSN_INTERIM_MASK = 'XXXXXXXXXXXX'

export const SSN_INTERIM_MASK_OPTIONS = {
  lazy: true,
  definitions: {
    X: /[0-9A-Za-z]/,
  },
} as const

export function getSsnMask(allowInterimNumber: boolean): string {
  return allowInterimNumber ? SSN_INTERIM_MASK : SSN_MASK
}

export function getSsnMaskOptions(allowInterimNumber: boolean) {
  return allowInterimNumber ? SSN_INTERIM_MASK_OPTIONS : { lazy: true }
}
